export const SUPPORTED_REGIONS = [
  'north-america'
  // , 'central-america'
]
